import React, { Component } from 'react';
import { Row, Col, Card, Input, Button, Select } from 'antd';
import Cookies from 'js-cookie';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import CooperationStatesSelect, { CooperationStates } from '../../components/public/CooperationStatesSelect';
import CustomerManagerTable from './CustomerManagerTable';
import './page-customer-manager.less';

interface CustomerManagerPageState {
    nameInputValue: string;
    managerTypeValue: number | null;
    statesSelectValue: number | null;
}

class CustomerManagerPage extends Component<any, CustomerManagerPageState> {
    state: CustomerManagerPageState = {
        nameInputValue: '',
        managerTypeValue: null,
        statesSelectValue: CooperationStates.normal,
    };

    customerManagerTableRef: CustomerManagerTable;

    componentDidMount(): void {
        if (this.customerManagerTableRef) {
            this.customerManagerTableRef.getCustomerManagerTableData(1,
                this.state.nameInputValue,
                this.state.managerTypeValue,
                this.state.statesSelectValue
            );
        }
    }

    handleQueryButtonClick = async () => {
        if (this.customerManagerTableRef) {
            await this.customerManagerTableRef.getCustomerManagerTableData(1,
                this.state.nameInputValue,
                this.state.managerTypeValue,
                this.state.statesSelectValue
            );
            this.customerManagerTableRef.setPaginationPage(1);
        }
    };

    handleAddButtonClick = () => {
        window.location.href = '/#/app/customerManager/manager';
    };

    canCreateExternal = () => {
        const role = parseInt(Cookies.get('userRole') || '0', 10);
        const roleParts = new Set<number>();
        let remain = role;
        [1000, 100, 10, 2, 1].forEach((part) => {
            if (remain >= part) {
                remain -= part;
                roleParts.add(part);
            }
        });
        if (remain !== 0) {
            roleParts.clear();
            roleParts.add(role);
        }
        return roleParts.has(1) || roleParts.has(100) || roleParts.has(1000);
    };

    render() {
        return (
            <div className="gutter-customer-manager_container">
                <BreadcrumbCustom breads={['客户经理管理', '客户经理列表']} />
                <Row gutter={5}>
                    <Col className="gutter-customer-manager_row" md={23}>
                        <div className="gutter-customer-manager_box">
                            <Card title="客户经理列表" bordered={false}>
                                <div style={{ marginBottom: 16 }}>
                                    <label className="label-customer-manager_name">姓名：</label>
                                    <Input
                                        placeholder="按姓名查询"
                                        className="input-customer-manager_name"
                                        value={this.state.nameInputValue}
                                        onChange={(e) => this.setState({ nameInputValue: e.target.value })}
                                        allowClear
                                    />

                                    <label className="label-customer-manager_type">类型：</label>
                                    <Select
                                        className="select-customer-manager_type"
                                        value={this.state.managerTypeValue !== null ? this.state.managerTypeValue : undefined}
                                        allowClear
                                        placeholder="全部"
                                        onChange={(value) => this.setState({ managerTypeValue: value !== undefined ? value : null })}
                                    >
                                        <Select.Option value={1}>内部销售</Select.Option>
                                        <Select.Option value={2}>外部渠道</Select.Option>
                                    </Select>

                                    <label className="label-customer-manager_state">状态：</label>
                                    <CooperationStatesSelect
                                        initialValues={CooperationStates.normal}
                                        onChange={(value) => this.setState({ statesSelectValue: value })}
                                    />

                                    <Button className="button-customer-manager_query" type="primary" onClick={this.handleQueryButtonClick}>
                                        查询
                                    </Button>

                                    {this.canCreateExternal() && (
                                        <Button className="button-customer-manager_add" type="primary" onClick={this.handleAddButtonClick}>
                                            新建外部渠道
                                        </Button>
                                    )}
                                </div>

                                <CustomerManagerTable
                                    ref={(ref) => (this.customerManagerTableRef = ref)}
                                />
                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CustomerManagerPage;
